import { userConstants } from './../constants/UserConstants';
import { cartConstants } from './../constants/CartConstants';
import UserService from './../services/UserService';
import { getCart } from './CartActions';
import { history } from './../helpers/history';
import { ModalsGaTracker, EventsGaTracker } from '../useGATracker';
import { mayoriaEdad } from '../constants/AccountConstants';
import { modalConstants } from '../constants/ModalConstants';
import { useLocation } from 'react-router-dom';
import RespFavorite$ from './../events/emitter';
import { pushDataLayerEvent } from '../utils/metricManagementUtil';
const favoriteEnv = process.env.REACT_APP_FAVORITE_NUMBER;

//====================================================================
// Toggle Modal for login or create account
//====================================================================

const registerUserClear = () => ({
  type: userConstants.REGISTER_USER_CLEAR
});

const loginUserClear = () => ({
  type: userConstants.LOGIN_USER_CLEAR
});

export const applicationChangePasswordClear = () => ({
  type: userConstants.REQUEST_CHANGE_PASSWORD_CLEAR
});

export const ChangePasswordClear = () => ({
  type: userConstants.CHANGE_PASSWORD_CLEAR
});

export const updateUserClear = () => ({
  type: userConstants.UPDATE_USER_CLEAR
});

export const deleteUserClear = () => ({
  type: userConstants.DELETE_USER_CLEAR
});

export const toggleModalLogin = (tab) => (dispatch) => {
  dispatch({
    type: userConstants.TOGGLE_MODAL_LOGIN,
    tab: tab
  });

  if (tab === 'login') {
    pushDataLayerEvent({
      event: 'form_start',
      form_type: 'login',
      form_id: 'login-form',
      form_name: 'Iniciar sesión',
      page_path: window.location.pathname,
      page_url: window.location.href
    });
  }

  if (tab === 'register') {
    pushDataLayerEvent({
      event: 'form_start',
      form_type: 'register',
      form_id: 'register-form',
      form_name: 'Registro',
      page_path: window.location.pathname,
      page_url: window.location.href
    });
  }

  if (!tab) {
    dispatch(registerUserClear());
    dispatch(loginUserClear());
    dispatch(applicationChangePasswordClear());
    dispatch(updateUserClear());
    dispatch(deleteUserClear());
  }
};

export const toggleModalUpdate = () => (dispatch) => {
  dispatch({
    type: modalConstants.TOGGLE_MODAL_UPDATE
  });
};

export const toggleModalFavorite = () => (dispatch) => {
  dispatch({
    type: modalConstants.TOGGLE_MODAL_FAVORITE
  });
};

//====================================================================
// Register a new user to the db
//====================================================================

export const registerUser = (values) => (dispatch) => {

  dispatch({ type: userConstants.REGISTER_USER_REQUEST });

  setTimeout(() => {
    UserService.register(values).then(

      response => {
        pushDataLayerEvent({
          event: 'form_submit',
          form_type: 'register',
          form_id: 'register-form',
          form_name: 'Registro',
          status: 'success',
          page_path: window.location.pathname,
          page_url: window.location.href
        });

        pushDataLayerEvent({
          event: 'sign_up',
          form_type: 'register',
          form_id: 'register-form',
          form_name: 'Registro',
          status: 'success',
          user_id: response?.userId || null,
          page_path: window.location.pathname,
          page_url: window.location.href
        });

        dispatch({
          type: userConstants.REGISTER_USER_SUCCESS,
          payload: response
        });
      },

      error => {
        error.then(errorResponse => {

          pushDataLayerEvent({
            event: 'form_submit',
            form_type: 'register',
            form_id: 'register-form',
            form_name: 'Registro',
            status: 'error',
            page_path: window.location.pathname,
            page_url: window.location.href
          });

          const errorMessage = JSON.parse(errorResponse.message.split('-')[1]);
          dispatch({
            type: userConstants.REGISTER_USER_FAILURE,
            payload: errorMessage.mensaje ||
              'Ocurrió un error al momento de Crear la cuenta.'
          });
        });
      }
    );
  }, 500);
};


//====================================================================
// Update user
//====================================================================

export const updateUser = (values) => (dispatch) => {

  const updateUserRequest = () => ({
    type: userConstants.UPDATE_USER_REQUEST
  });

  const updateUserSuccess = (payload) => ({
    type: userConstants.UPDATE_USER_SUCCESS,
    payload
  });

  const updateUserError = error => ({
    type: userConstants.UPDATE_USER_FAILURE,
    error
  });

  dispatch(updateUserRequest());
  setTimeout(() => {
    UserService.update(values)
      .then(
        user => {
          pushDataLayerEvent({
            event: 'update_user',
            user_id: user?.userId,
            page_path: window.location.pathname,
            page_url: window.location.href
          });
          
          dispatch(updateUserSuccess(user));
          dispatch(getUserInfo());
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = JSON.parse(errorResponse.message.split('-')[1]);
            dispatch(updateUserError(errorMessage.mensaje ? errorMessage.mensaje :
              'Ocurrió un error al momento de Crear la cuenta. Inténtalo nuevamente o contáctanos para reportar tu problema.'));
          });
        }
      );
  }, 500);
};

//====================================================================
// Update user
//====================================================================

export const deleteUser = (values) => (dispatch) => {
  const deleteUserRequest = () => ({
    type: userConstants.DELETE_USER_REQUEST
  });

  const deleteUserSuccess = (payload) => ({
    type: userConstants.DELETE_USER_SUCCESS,
    payload
  });

  const deleteUserError = (payload) => ({
    type: userConstants.DELETE_USER_FAILURE,
    payload
  });

  dispatch(deleteUserRequest());
  setTimeout(() => {
    UserService.deleteUser(values)
      .then(
        user => {
          dispatch(deleteUserSuccess(user.data));
          if (user.toEliminar) {
            pushDataLayerEvent({
              event: 'delete_user',
              user_id: user?.userId,
              page_path: window.location.pathname
            });
            
            history.push('/eliminar');
            history.go();
          }
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = errorResponse.error;
            dispatch(deleteUserError(errorMessage.error.mensaje ? errorMessage.error.mensaje :
              'Ocurrió un error al momento de Eliminar el usuario. Inténtalo más tarde'));
          });
        }
      );
  }, 500);
};
//====================================================================
// Get user Info
//====================================================================

export const getUserInfo = () => (dispatch, getState) => {

  const user = getState().authentication.user;
  EventsGaTracker('user', 'Consultar informacion de usuario', 'UserConsulta');
  if (user) {
    const body = {
      'token': user.token,
      'tipoDocumento': user.tipoDocumento,
      'usuario': user.usuario
    };

    const getUserRequest = () => ({
      type: userConstants.GET_USER_REQUEST
    });

    const getUserSuccess = (payload) => ({
      type: userConstants.GET_USER_SUCCESS,
      payload
    });

    const getUserError = error => ({
      type: userConstants.GET_USER_FAILURE,
      error
    });

    dispatch(getUserRequest());
    UserService.getInfo(body)
      .then(
        user => {
          //const pathname = window.location.pathname;
          const local = JSON.parse(localStorage.getItem('userLoti'));
          if (local.comercial) {
            user.data.comercial = true;
          }
          /* if (local.mayoriaEdad === mayoriaEdad.PENDIENTE && !pathname.includes('/mi-cuenta')) {
            dispatch(toggleModalUpdate());
          } */
          localStorage.setItem('userLoti', JSON.stringify(user.data));
          dispatch(getUserSuccess(user.data));
        },
        error => {
          if (error === 'Unauthorized') {
            dispatch(getUserError('Debes de volver a iniciar sesión'));
          } else {
            dispatch(getUserError(error.message ? error.message : 'Ocurrió un error al momento de Actualizar su información. Inténtalo más tarde'));
          }
          dispatch(logoutUser());
        }
      );
  }
};

//====================================================================
// Login user
//====================================================================

export const loginUser = (values) => (dispatch) => {

  dispatch({ type: userConstants.LOGIN_USER_REQUEST });

  setTimeout(() => {
    UserService.login(values).then(

      user => {
        if (user?.token) {
          localStorage.setItem('userLoti', JSON.stringify(user));

          pushDataLayerEvent({
            event: 'form_submit',
            form_type: 'login',
            form_id: 'login-form',
            form_name: 'Iniciar sesión',
            status: 'success',
            page_path: window.location.pathname,
            page_url: window.location.href
          });

          pushDataLayerEvent({
            event: 'login',
            form_type: 'login',
            form_id: 'login-form',
            form_name: 'Iniciar sesión',
            status: 'success',
            user_id: user?.userId || null,
            page_path: window.location.pathname,
            page_url: window.location.href
          });

          dispatch({
            type: userConstants.LOGIN_USER_SUCCESS,
            payload: user
          });

        } else {
          pushDataLayerEvent({
            event: 'form_submit',
            form_type: 'login',
            form_id: 'login-form',
            form_name: 'Iniciar sesión',
            status: 'error',
            page_path: window.location.pathname,
            page_url: window.location.href
          });

          dispatch({
            type: userConstants.LOGIN_USER_FAILURE,
            payload: 'Usuario o clave inválida'
          });
        }
      },

      () => {
        pushDataLayerEvent({
          event: 'form_submit',
          form_type: 'login',
          form_id: 'login-form',
          form_name: 'Iniciar sesión',
          status: 'error',
          page_path: window.location.pathname,
          page_url: window.location.href
        });

        dispatch({
          type: userConstants.LOGIN_USER_FAILURE,
          payload: 'Usuario o clave inválida'
        });
      }
    );
  }, 500);
};

//====================================================================
// Favorite
//====================================================================

export const favoriteNumber = (values) => (dispatch) => {
  setTimeout(() => {

    UserService.getUserArray(values)
      .then(
        user => {
          if (user && user.token) {
            localStorage.setItem('userLoti2', JSON.stringify(user));
            setTimeout(() => {
              const data = '2222 envio el mensaje';
              RespFavorite$.emit('myEvent2', data);

              dispatch(toggleModalFavorite());
            }, 3000);


          }
        }
      );
  }, 500);
};


//====================================================================
// Logout user
//====================================================================

export const logoutUser = () => (dispatch) => {
  UserService.logout();
  dispatch({ type: userConstants.LOGOUT_USER });
  dispatch({ type: cartConstants.CLEAR_CART });

  localStorage.clear();

  pushDataLayerEvent({
    event: 'logout',
    page_path: window.location.pathname,
    page_url: window.location.href
  });
};

//====================================================================
// Activate Account
//====================================================================

export const activeAccount = (values) => (dispatch) => {
  const applicationActiveAccountRequest = () => ({
    type: userConstants.REQUEST_ACTIVE_ACCOUNT
  });
  const applicationActiveAccountRequestSuccess = (payload) => ({
    type: userConstants.REQUEST_ACTIVE_ACCOUNT_SUCCESS,
    payload
  });
  const applicationActiveAccountRequestError = (payload) => ({
    type: userConstants.REQUEST_ACTIVE_ACCOUNT_FAILURE,
    payload
  });

  dispatch(applicationActiveAccountRequest());
  setTimeout(() => {
    UserService.activeAccount(values)
      .then(
        user => {
          dispatch(applicationActiveAccountRequestSuccess(user.data));
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = JSON.parse(errorResponse.message.split('-')[1]);
            dispatch(applicationActiveAccountRequestError(errorMessage.mensaje ? errorMessage.mensaje :
              'Ocurrió un error al momento de Crear la cuenta. Inténtalo nuevamente o contáctanos para reportar tu problema.'));
          });
        }
      );
  }, 500);
};

//====================================================================
// getUserWithToken
//====================================================================

export const getUserWithToken = (values) => (dispatch) => {
  const getUserWithToken = () => ({
    type: userConstants.GET_USER_WITH_TOKEN_REQUEST
  });
  const getUserWithTokenSuccess = (payload) => ({
    type: userConstants.GET_USER_WITH_TOKEN_SUCCESS,
    payload
  });
  const getUserWithTokenError = (payload) => ({
    type: userConstants.GET_USER_WITH_TOKEN_FAILURE,
    payload
  });
  dispatch(getUserWithToken());
  setTimeout(() => {
    UserService.getUserWithToken(values)
      .then(
        user => {
          dispatch(getUserWithTokenSuccess(user.data));
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = errorResponse.error;
            dispatch(getUserWithTokenError(errorMessage.error ? errorMessage.error : errorMessage));
          });
        }
      );
  }, 500);
};

//====================================================================
// recoveryPassword web
//====================================================================

export const recoveryPassword = (values) => (dispatch) => {
  const recoveryPassword = () => ({
    type: userConstants.RECOVERY_PASSWORD_REQUEST
  });
  const recoveryPasswordSuccess = (payload) => ({
    type: userConstants.RECOVERY_PASSWORD_SUCCESS,
    payload
  });
  const recoveryPasswordError = (payload) => ({
    type: userConstants.RECOVERY_PASSWORD_FAILURE,
    payload
  });
  dispatch(recoveryPassword());
  setTimeout(() => {
    UserService.changePasswordWeb(values)
      .then(
        user => {
          dispatch(recoveryPasswordSuccess(user.data));
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = errorResponse.error;
            dispatch(recoveryPasswordError(errorMessage.error ? errorMessage.error : errorMessage));
          });
        }
      );
  }, 500);
};


//====================================================================
// Request change password
//====================================================================

export const applicationChangePassword = (values) => (dispatch) => {

  const applicationChangePasswordRequest = () => ({
    type: userConstants.REQUEST_CHANGE_PASSWORD_REQUEST
  });

  const applicationChangePasswordSuccess = () => ({
    type: userConstants.REQUEST_CHANGE_PASSWORD_SUCCESS
  });

  const applicationChangePasswordError = payload => ({
    type: userConstants.REQUEST_CHANGE_PASSWORD_FAILURE,
    payload
  });

  dispatch(applicationChangePasswordRequest());
  setTimeout(() => {
    UserService.changePasswordRequest(values)
      .then(
        user => {
          dispatch(applicationChangePasswordSuccess());
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = errorResponse.error;
            dispatch(applicationChangePasswordError(errorMessage.error.mensaje ? errorMessage.error.mensaje : 'Ocurrió un error al momento de solicitar el cambio de contraseña. Inténtalo más tarde'));
          });
        }
      );
  }, 500);
};

//====================================================================
// Change password
//====================================================================

export const changePassword = (values) => (dispatch) => {

  const changePasswordRequest = () => ({
    type: userConstants.CHANGE_PASSWORD_REQUEST
  });

  const changePasswordSuccess = () => ({
    type: userConstants.CHANGE_PASSWORD_SUCCESS
  });

  const changePasswordError = payload => ({
    type: userConstants.CHANGE_PASSWORD_FAILURE,
    payload
  });

  dispatch(changePasswordRequest());
  setTimeout(() => {
    UserService.changePassword(values)
      .then(
        user => {
          dispatch((typeof user.data.mensaje != 'undefined' && user.data.mensaje != ' Clave inválida') ? changePasswordSuccess() : changePasswordError(user.data.mensaje));
        },
        error => {
          error.then(errorResponse => {
            const errorMessage = errorResponse.error;
            dispatch(changePasswordError(errorMessage.error.mensaje ? errorMessage.error.mensaje : 'Ocurrió un error al momento de cambiar la contraseña. Inténtalo más tarde'));
          });
        }
      );
  }, 500);
};
